import { render } from "./MissionContent.vue?vue&type=template&id=2c120f5c&scoped=true&ts=true"
import script from "./MissionContent.vue?vue&type=script&lang=ts"
export * from "./MissionContent.vue?vue&type=script&lang=ts"

import "./MissionContent.vue?vue&type=style&index=0&id=2c120f5c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\manya\\Documents\\Development\\Production\\Vue\\bbf-africa-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c120f5c"]])

export default __exports__